var comment = { exports: {} };
export {
  comment as __module
};
//# sourceMappingURL=comment.js.map
